import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const DevelopmentList = memo(({ developer, imageUrl }) => {
  const { t } = useTranslation();
  return (
    <div className="development__i--container">
      {imageUrl && (
        <img
          className="development__i development__i--img"
          src={imageUrl}
          alt={t('residences.logo', { name: developer })}
        />
      )}
      {developer && (
        <div className="development__i development__i--developer">
          {t('residences.title', { name: developer })}
        </div>
      )}
    </div>
  );
});

DevelopmentList.displayName = `DevelopmentList`;

DevelopmentList.propTypes = {
  deadline: PropTypes.string,
  developer: PropTypes.string,
  imageUrl: PropTypes.string
};

export default DevelopmentList;
